<template>
  <section
    class="burger"
    @click="toggleMenu"
  >
    <div class="hover" />
    <div class="burger__line" />
  </section>
</template>

<script>
export default {
  name: 'Burger',

  methods: {
    toggleMenu() {
      this.$store.commit('TOGGLE_MENU');
    },
  },
};
</script>

<style lang="scss" scoped>
.burger {
  position: relative;
  padding-top: 5px;
  cursor: pointer;

  z-index: 3;

  &__line {
    position: absolute;
  }

  div {
    display: block;
    width: 100%;
    height: 15px;

    background: RGB($color-text);

    &.hover {
      position: absolute;

      top: -3px;
      transform: translate3d(0, -100%, 0) scaleX(0);
      transform-origin: 0% 50%;

      pointer-events: none;

      transition: all 0.2s ease-out;
    }
  }

  @include mq(ipadP) {
    &:hover {
      .hover {
        transform: translate3d(0, -100%, 0) scaleX(1);
        pointer-events: auto;
      }
    }
  }


  @include mq($until: ipadP) {
    padding-top: 0;
    width: 26px;

    div {
      &.hover {
        position: relative;
        top: 0;
        margin-bottom: 6px;

        transform: translate3d(0, 0%, 0) scaleX(1);
      }
    }
  }
}

</style>
